import styled from '@emotion/styled';
import theme from '../../constants/theme';

type TextProps = {
  textAlign?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  color?: string;
  theme?: typeof theme;
  ctaColor?: string;
  fontFamily?:string;
};

const Text = styled.p<TextProps>`
  a:link {
    color: ${(props) => props.ctaColor && props.ctaColor};
    text-decoration: none;
  }
  font-style: normal;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Poppins')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  line-height: ${(props) => (props.lineHeight ? `${props.lineHeight}` : '24px')};
  color: ${(props) => (props.color ? props.color : props.theme.colors.darkGrey)};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
`;

export default Text;
